// 將西元日期字串轉為民國年月日格式
export const toROCDate = (dateStr: string): string => {
    if (!dateStr) return '';

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr; // 如果日期無效，直接回傳原字串

    const rocYear = date.getFullYear() - 1911;
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${rocYear}/${month}/${day}`;
};